<template>
  <v-card outlined raised>
    <v-card-title>My Record Permissions</v-card-title>

    <v-data-table
      :headers="headers"
      :items="delegates"
      :items-per-page="5"
      class="elevation-1"
    ></v-data-table>
  </v-card>
</template>

<script>
export default {
  props: { delegates: Array },
  computed: {},
  data() {
    return {
      headers: [
        {
          text: "Authorized Users",
          align: "start",
          sortable: false,
          value: "username"
        },
        {
          text: "Delegate",
          align: "start",
          sortable: false,
          value: "delegate"
        }
      ]
    };
  }
};
</script>

<style></style>
